<template>
  <UButton
    v-if="showFavoriteButton"
    :aria-label="t('a11y.favorite-button')"
    v-bind="
      isFavorite
        ? { variant: 'soft', color: 'red', icon: 'i-heroicons-heart-20-solid' }
        : { variant: 'solid', color: 'white', icon: 'i-heroicons-heart' }
    "
    size="md"
    class="absolute top-4 right-4 z-10"
    @click="handleFavoriteButton()"
  />
  <AuthModal v-model="modalIsOpen">
    <template #default>
      <CottageBookmarks
        :item="item"
        @submit-success="closeModal"
      ></CottageBookmarks>
    </template>
  </AuthModal>
</template>

<script setup lang="ts">
import fetchBookmarkDelete from '~/modules/api/rurality/v3/bookmarks/delete'
import { useUserStore } from '~/modules/auth/stores/userStore'
import type { CottagePage } from '../entities/CottagePage'

const userStore = useUserStore()

const modalIsOpen = ref(false)
const showFavoriteButton = ref<boolean>(false)
const isFavorite = ref<boolean>(false)

const user = userStore.getUserdata

type itemType = Pick<
  CottagePage,
  'media' | 'name' | 'village' | 'province' | 'id'
>

interface propsInterface {
  item: itemType
}

const props = defineProps<propsInterface>()

const closeModal = async () => {
  modalIsOpen.value = false
}

const handleFavoriteButton = async () => {
  if (isFavorite.value) {
    const data = await fetchBookmarkDelete({
      cottageUid: props.item.id,
    })
    if (data.success) {
      isFavorite.value = false
    }
  } else {
    modalIsOpen.value = true
  }
}

const init = async () => {
  if (!user.logged) {
    showFavoriteButton.value = true
  } else if (user.logged && user.params?.cottage_bookmarks) {
    showFavoriteButton.value = true
    const cottageBookmarks = userStore.params?.cottage_bookmarks || []
    isFavorite.value = cottageBookmarks.some(
      (bookmark: { cottageId: string }) => bookmark.cottageId === props.item.id,
    )
  }
}

const unsubscribe = userStore.$subscribe(() => {
  init()
})
onUnmounted(() => {
  unsubscribe()
})

watchEffect(() => {
  const cottageBookmarks = userStore.params?.cottage_bookmarks || []
  isFavorite.value = cottageBookmarks.some(
    (bookmark: { cottageId: string }) => bookmark.cottageId === props.item.id,
  )
})

onMounted(() => {
  init()
})
</script>
